import React from 'react';
import ReactDOM from 'react-dom/client';
import PdfDescription from './PdfDescription';
import PDF_STYLES from './PdfStyles';

export function createMeasureContainer() {
  const el = document.createElement('div');
  el.style.cssText = 'position:absolute;left:-19999px;top:0;z-index:-1;pointer-events:none;';
  document.body.appendChild(el);
  const style = document.createElement('style');
  style.textContent = PDF_STYLES;
  el.appendChild(style);
  return el;
}

export function destroyMeasureContainer(el) {
  if (el?.parentNode) el.parentNode.removeChild(el);
}

async function measureSplitIdx(descData, paras, pageIndex, officeName, dateLabel, container) {
  const div = document.createElement('div');
  div.style.cssText = 'position:relative;';
  container.appendChild(div);

  const root = ReactDOM.createRoot(div);
  root.render(
    <PdfDescription
      data={{ ...descData, paragraphs: paras }}
      officeName={officeName}
      dateLabel={dateLabel}
      pageIndex={pageIndex}
    />
  );
  await new Promise((r) => setTimeout(r, 150));

  const pdfPage = div.querySelector('.pdf-page');
  const paraEls = div.querySelectorAll('.prose p');
  let splitIdx = paras.length;

  if (pdfPage && paraEls.length > 0) {
    const pageBottom = pdfPage.getBoundingClientRect().bottom;
    for (let i = 0; i < paraEls.length; i++) {
      if (paraEls[i].getBoundingClientRect().bottom > pageBottom - 6) {
        splitIdx = i;
        break;
      }
    }
    if (splitIdx === 0) splitIdx = 1;
  }

  root.unmount();
  container.removeChild(div);
  return splitIdx;
}

export async function splitDescriptionParas(descData, officeName, dateLabel, container) {
  const allParas = (descData.body || '').split('\n').filter(Boolean);
  if (allParas.length === 0) return [[]];

  const chunks = [];
  let remaining = [...allParas];
  let pageIndex = 0;

  while (remaining.length > 0) {
    const idx = await measureSplitIdx(descData, remaining, pageIndex, officeName, dateLabel, container);
    chunks.push(remaining.slice(0, idx));
    remaining = remaining.slice(idx);
    pageIndex++;
  }

  return chunks;
}
